export const useFooterViewModel = () => {
    const currentYear = new Date().getFullYear();
    return {
        currentYear,
    };
};